export enum PropertiesActionType {
  SET_PROPERTIES = 'SET_PROPERTIES',
  SEARCH_PROPERTIES = 'SEARCH_PROPERTIES',
  SET_PROPERTIES_PAGINATION = 'SET_PROPERTIES_PAGINATION',
  SET_PROPERTIES_AFTER_SCROLL = 'SET_PROPERTIES_AFTER_SCROLL',
  SET_CERTAIN_PROPERTY = 'SET_CERTAIN_PROPERTY',
  SET_UPLOADED_CSV = 'SET_UPLOADED_CSV',
  SET_PROPERTIES_LOADING_STATUS = 'SET_PROPERTIES_LOADING_STATUS',
}
